module.exports = fox._r("fonts/stateoff.svg?c8mros", __webpack_public_path__ + "_/_/_/root/fonts/stateoff.svg");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/fonts/stateoff.svg?c8mros
// module id = 419
// module chunks = 4